export default function toColorValue(maybeFunction) {
  return typeof maybeFunction === 'function' ? maybeFunction({}) : maybeFunction
}
